import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState,
} from '../../utils/redux';

export const consts = createReqConsts('surveys', 'submit', [
  'CLEAR',
  'MESSAGE',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'put',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'upcoming_assignments',
    {
      type: 'payload',
      selector: ['surveyId'],
    },
  ],
});

const requestReducer = createReqReducer(consts);

export default (state, action) => {
  const { type } = action;

  switch (type) {
    case consts.CLEAR:
      return initialState;
    default:
      return requestReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/surveys/submit.js